/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/AffinitySearchResultsSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.affinitySearchResults || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.isAffinitySearchLoading,
);

export const selectBuyerLoading = createSelector(
  [selectDomain],
  (state) => state.isBuyerAffinitySearchLoading,
);

export const selectExtendedLoading = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoading,
);

export const selectBuyerExtendedLoading = createSelector(
  [selectDomain],
  (state) => state.isbuyerPersonExtendedLoading,
);

export const selectPeopleData = createSelector([selectDomain], (state) => state.peopleSection);

export const selectBuyerPeopleData = createSelector(
  [selectDomain],
  (state) => state.buyerPeopleSection,
);

export const selectSearchText = createSelector([selectDomain], (state) => state.searchText);

export const selectErrorText = createSelector(
  [selectDomain],
  (state) => state.errorText,
);

export const selectSearchLoaded = createSelector(
  [selectDomain],
  (state) => state.isAffinitySearchLoaded,
);
export const selectExtendedSearchLoaded = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoaded,
);

export const selectIsPagination = createSelector(
  [selectDomain],
  (state) => state.isPagination,
);

export const selectSearchResultsPage = createSelector(
  [selectDomain],
  (state) => state.searchResultsPage,
);

export const selectAffinitySelectedPersonId = createSelector(
  [selectDomain],
  (state) => state.selectedPersonId,
);

export const selectedSalesPopoverPeopleData = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverPeopleSection[rowId],
);

export const selectedSalesPopoverLoading = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverLoading[rowId],
);

export const selectedSalesPopoverLoaded = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverLoaded[rowId],
);

export const selectedSalesPopoverExtendedLoading = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverExtendedLoading[rowId],
);

export const selectedSalesPopoverExtendedLoaded = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverExtendedLoaded[rowId],
);

export const selectedSalesPopoverResultsPage = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.salesPopoverResultsPage[rowId],
);

export const selectedAddRowPopoverPeopleData = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverPeopleSection[rowId],
);

export const selectedAddRowPopoverLoading = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverLoading[rowId],
);

export const selectedAddRowPopoverLoaded = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverLoaded[rowId],
);

export const selectedAddRowPopoverExtendedLoading = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverExtendedLoading[rowId],
);

export const selectedAddRowPopoverExtendedLoaded = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverExtendedLoaded[rowId],
);

export const selectedAddRowPopoverResultsPage = (rowId: number) => createSelector(
  [selectDomain],
  (state) => state.addRowPopoverResultsPage[rowId],
);

